<main class="grow" role="content">
  <div class="kt-container-fixed py-8">
    <div class="kt-card auth-callback-card">
      <div class="kt-card-content">
        <div class="auth-callback-spinner" aria-hidden="true"></div>
        <p class="auth-callback-text">Signing you in...</p>
      </div>
    </div>
  </div>
</main>
